import { Dialog, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ScreenShareDeviceType } from '../..';
import {
  Tile,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
} from './styles';

type ScreenShareSelectorType = {
  open: boolean;
  handleClose: () => void;
  handleScreenShareSelection: (screenId: string) => void;
  devices: ScreenShareDeviceType[];
};

export default function ScreenShareSelector({
  open,
  handleClose,
  handleScreenShareSelection,
  devices,
}: ScreenShareSelectorType) {
  // HOOK's
  const { t } = useTranslation();

  // STATE's
  const [screenSelected, setScreenSelected] = useState<string>('');

  const handleCloseSelector = () => {
    setScreenSelected('');
    handleClose();
  };

  const handleShareAction = (windowId: string) => {
    if (windowId && windowId.length > 0) {
      handleScreenShareSelection(windowId);
      setScreenSelected('');
    }
  };

  return (
    <Dialog
      maxWidth="lg"
      open={open}
      onClose={handleCloseSelector}
      aria-labelledby="customized-dialog-title">
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <div>
          <Typography variant="h6">
            {t('screens.video.screenShareSelector.title')}
          </Typography>
          <Typography variant="subtitle1" id="subTitle">
            {t('screens.video.screenShareSelector.subTitle')}
          </Typography>
        </div>
        <IconButton aria-label="close" onClick={handleClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {devices.map(device => (
          <Tile
            id={device.id}
            onClick={() => setScreenSelected(device.id)}
            selected={screenSelected === device.id}>
            <div style={{ height: 170 }}>
              <img id={device.id} src={device.thumbnail} alt={device.name} />
            </div>
            <span aria-label={device.name}>{device.name}</span>
          </Tile>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          disableElevation
          onClick={handleCloseSelector}
          color="default">
          {t('screens.video.screenShareSelector.cancelBtn')}
        </Button>
        <Button
          autoFocus
          disableRipple
          disableElevation
          variant="contained"
          onClick={() => handleShareAction(screenSelected)}
          disable={screenSelected === ''}
          color={screenSelected !== '' ? 'primary' : 'default'}>
          {t('screens.video.screenShareSelector.shareBtn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
